import styled, { css } from 'styled-components';
import { LayoutType } from '../../types';

interface WidgetProps {
	layout: LayoutType,
	spacious: boolean
}

const getLayoutStyles = (props: WidgetProps) => {
	switch (props.layout) {
		case 'box':
			return css`;
				max-width: 400px;
			`;
		case 'button':
			return css`;
				max-width: 400px;
			`;
		case 'bar':
			return css`;
				max-width: 100%;

				${Inner} {
					display: flex;
					flex-flow: row nowrap;
					align-items: center;
					padding: 15px 35px;
				}

				${Title} {
					min-width: 250px;
					margin: 0;
					text-align: left;
				}

				${Amounts} {
					align-self: flex-end;
					margin-left: auto;
				}

				${Footer} {
					margin: 0 0 0 20px;
				}
			`;
		case 'footer':
			return css`;
				max-width: 100%;

				${Inner} {
					display: flex;
					flex-flow: column;
					align-items: center;
				}

				${PoweredBy} {
					margin: 20px 0 0;
				}
			`;
	}
}

export const Container = styled.div`
	width: 100%;
`;

export const Heading = styled.h2`
	font-weight: normal;
	text-transform: uppercase;
	text-align: center;
	user-select: none;
`;

export const PoweredBy = styled.div`
	margin-left: auto;
	font-family: "Helvetica Neue", "Open Sans", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, -apple-system, BlinkMacSystemFont, sans-serif;
	font-size: 0.7rem;
	color: #A0A0A0;
	svg {
		opacity: 0.6;
		vertical-align: middle;
	}
`;


export const Menu = styled.div<WidgetProps>`
	position: relative;
	width: 100%;
	margin: 0 auto

	${(props) => getLayoutStyles(props)};

	@media (max-width: ${(props) => (props.layout === 'footer' || props.layout === 'bar') && props.spacious ? '1720': '1350'}px) {
		transform: scale(0.8);
		${PoweredBy} {
			display: none;
		}
	}
`;

export const Inner = styled.div`
	display: flex;
	flex-flow: column;
	padding: 25px 35px 35px;
	border-radius: 5px;
	font-family: "Helvetica Neue","Open Sans","Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,-apple-system,BlinkMacSystemFont,sans-serif;
	box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
	background-color: #fff
`;

export const Amounts = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
`;

export const Amount = styled.div`
	min-width: 75px;
	border: 2px solid #1d1d1d;
	border-radius: 5px;
	margin: 0 2px 0;
	padding: 15px 0;
	font-size: 0.9rem;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	font-weight: bold;
	color: #1d1d1d;
	&:last-child {
		margin-right: 0;
	}
`;

export const Footer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
`;

export const FooterText = styled.span`
	font-size: 0.7rem;
	line-height: 1.4;
	color: #808080;
`;

export const FooterLink = styled.a`
	width: 75px;
	margin-left: 5px;
	opacity: 0.6;
	transition: opacity 0.2s ease-in;

	img {
		vertical-align: middle;
	}

	&:hover {
		opacity: 1;
	}
`;

export const ButtonPreview = styled.div`
	margin-bottom: 100px;
	text-align: center;

	${Footer} {
		margin-top: 10px;
	}
`;

export const Button = styled.button`
	max-width: 320px;
	padding: 15px 30px;
	border: 0;
	border-radius: 5px;
	font-family: "Helvetica Neue", "Open Sans", "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, -apple-system, BlinkMacSystemFont, sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #fff;
	background-color: #1d1d1d;
	text-decoration: none;
`;

export const Title = styled.h2`
	margin: 0 0 20px;
	font-weight: bold;
	line-height: 1.33;
	font-size: 1.4rem;
	text-align: center;
	color: #1d1d1d;
`;

export const AmountValue = styled.div`
	width: 40px;
	margin: 0;
	border: 0;
`;

export const Content = styled.p`
	margin-top: -10px;
	font-size: 1rem;
	text-align: center;
`;
